import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';
/* eslint-disable max-len */

export interface IFerriesAdditionalBookingSectionsAttributes extends IModelAttributes {
	ferriesId: string;
	additionalBookingSectionsId: string;

	ferries: Models.FerryEntity | Models.IFerryEntityAttributes;
	additionalBookingSections: Models.AdditionalBookingSectionEntity | Models.IAdditionalBookingSectionEntityAttributes;
}

@entity('FerriesAdditionalBookingSections')
export default class FerriesAdditionalBookingSections
	extends Model
	implements IFerriesAdditionalBookingSectionsAttributes
{
	@observable
	@attribute()
	public ferriesId: string;

	@observable
	@attribute()
	public additionalBookingSectionsId: string;

	@observable
	@attribute({ isReference: true })
	public ferries: Models.FerryEntity;

	@observable
	@attribute({ isReference: true })
	public additionalBookingSections: Models.AdditionalBookingSectionEntity;

	constructor(attributes?: Partial<IFerriesAdditionalBookingSectionsAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.ferriesId) {
				this.ferriesId = attributes.ferriesId;
			}
			if (attributes.additionalBookingSectionsId) {
				this.additionalBookingSectionsId = attributes.additionalBookingSectionsId;
			}

			if (attributes.ferries) {
				if (attributes.ferries instanceof Models.FerryEntity) {
					this.ferries = attributes.ferries;
					this.ferriesId = attributes.ferries.id;
				} else {
					this.ferries = new Models.FerryEntity(attributes.ferries);
					this.ferriesId = this.ferries.id;
				}
			} else if (attributes.ferriesId !== undefined) {
				this.ferriesId = attributes.ferriesId;
			}

			if (attributes.additionalBookingSections) {
				if (attributes.additionalBookingSections instanceof Models.AdditionalBookingSectionEntity) {
					this.additionalBookingSections = attributes.additionalBookingSections;
					this.additionalBookingSectionsId = attributes.additionalBookingSections.id;
				} else {
					this.additionalBookingSections = new Models.AdditionalBookingSectionEntity(
						attributes.additionalBookingSections,
					);
					this.additionalBookingSectionsId = this.additionalBookingSections.id;
				}
			} else if (attributes.additionalBookingSectionsId !== undefined) {
				this.additionalBookingSectionsId = attributes.additionalBookingSectionsId;
			}
		}
	}
}
